import { render, staticRenderFns } from "./TakeATour.vue?vue&type=template&id=253a8e3b&"
import script from "./TakeATour.vue?vue&type=script&lang=js&"
export * from "./TakeATour.vue?vue&type=script&lang=js&"
import style0 from "./TakeATour.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports